<template>
  <div class="table-responsive">
    <table class="table datatable table-striped table-hover w-100" data-order='[[ "0", "asc" ]]'>
      <thead>
        <tr>
          <th scope="col" data-name="name" data-sortable="true" data-class-name="text-center align-middle" class='text-center'>
              {{ I18n.t('name', locale_scope) }}
          </th>
          <th scope="col" data-name="products_count" data-sortable="true" data-class-name="text-center align-middle" class='text-center'>
              {{ I18n.t('products_count', locale_scope) }}
          </th>
          <th scope="col" data-name="" data-sortable="false" data-class-name="text-center align-middle" class='text-center'>
              {{ I18n.t('action') }}
          </th>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale_scope: {
        scope: 'activerecord.attributes.product_category'
      },
      dataTable: null,
    }
  },
  mounted() {
      this.dataTable = $(this.$el.querySelector(".datatable"))
        .DataTable({
          responsive: true,
          ajax: {
            url: `${window.location.pathname}.json`
          },
          language: {
            url: `/datatable.${I18n.currentLocale()}.lang.json`,
          },
        }).api().columns.adjust();
  },
  methods: {
    reloadTable(){
      this.dataTable.ajax.reload()
    },
  },
};
</script>

<style lang="scss" >

</style>
